import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";
import Storage from "../../Data/Domain/Storage";
import store from "../../Redux/store";
import {getOwnersSelector} from "../Infrastructure/DashboardOwner.reducer";

export async function getDashboardOwnerData(id, id_project) {
  try {
    const reduxOwnerData = getOwnersSelector(store.getState());
    const OwnerData = reduxOwnerData || new Storage("OwnerData").getItem();

    const endpoint =
      OwnerData && URL.buildUrl(`owners/${id}/projects/${id_project}/data`);

    return await new API(endpoint).get();
  } catch (error) {
    console.error(error);
  }
}
